import { render, staticRenderFns } from "./InstagramFeed.vue?vue&type=template&id=0480dba7&scoped=true"
import script from "./InstagramFeed.vue?vue&type=script&lang=js"
export * from "./InstagramFeed.vue?vue&type=script&lang=js"
import style0 from "./InstagramFeed.vue?vue&type=style&index=0&id=0480dba7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0480dba7",
  null
  
)

export default component.exports